import ReaderDialog, { ReaderDialogType } from "../../common/ReaderDialog";
import { useCallback, useState } from "react";
import { KEY_0 } from "keycode-js";
import useGlobalEvent from "../../../../framework/connectors/events/useGlobalEvent";
import ViewerEvent from "../../../../framework/api/core/ViewerEvent";
import { Toast } from "@vitalsource/vstui";
import useUser from "../../../../framework/connectors/user/useUser";
import { copyTextToClipboard } from "../../../../../../common/utils/copy";
import styled from "styled-components";
import { cloud, frost } from "@vitalsource/vstui/colors";

const DataContainer = styled.div`
  white-space: pre-wrap;
  font-family: monospace;
  background: ${frost.getShade(1)};
  border: 1px solid ${cloud.getShade(4)};
  padding: 16px;
  border-radius: 4px;
`;

function isSuppressedTarget(event) {
  return (
    ["INPUT", "TEXTAREA"].indexOf(event.target.nodeName.toUpperCase()) >= 0
  );
}

export default function CustomerDebug() {
  const [isOpen, setIsOpen] = useState(false);
  const { userInfo } = useUser();
  const [showingCopied, setShowingCopied] = useState(false);

  const keyHandler = useCallback((e) => {
    if (e.keyCode === KEY_0 && e.altKey && !isSuppressedTarget(e)) {
      setIsOpen(true);
    }
  }, []);

  useGlobalEvent(ViewerEvent.KEYUP, keyHandler);

  const jsonStr = JSON.stringify(
    {
      url: window.location.href,
      jigsawHost: window.Jigsaw?.host,
      email: userInfo?.email,
    },
    null,
    2
  );

  function doCopy() {
    copyTextToClipboard(jsonStr).then(() => {
      setShowingCopied(true);
    });
  }

  return (
    <>
      <ReaderDialog
        type={ReaderDialogType.Vstui}
        open={isOpen}
        onRequestClose={() => setIsOpen(false)}
        darkHeader
        title="Debug Info"
        customSize={800}
        primaryActionButton={{
          label: "Copy To Clipboard",
          onClick: doCopy,
        }}
      >
        <DataContainer>{jsonStr}</DataContainer>
      </ReaderDialog>
      <Toast
        open={showingCopied}
        toastClose={() => setShowingCopied(false)}
        toastType="success"
        toastTitleText="Copied!"
      />
    </>
  );
}
